// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Chart_canvas__3KEcA"};